export async function wait(ms: number): Promise<boolean> {
  return new Promise<boolean>((resolv) => {
    setTimeout(() => {
      resolv(true);
    }, ms);
  });
}

export function makeid(length = 5) {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
